import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gi-logo-image.png'


const _withScopeId = n => (_pushScopeId("data-v-63a97045"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  ref: "startLink"
}
const _hoisted_2 = { class: "influencer-navigation" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<a class=\"headers\" href=\"#about\" data-v-63a97045>About GameInfluencer.IO</a><a class=\"headers\" href=\"#platform\" data-v-63a97045>Platform Services</a><a class=\"headers\" href=\"#our-case-studies\" data-v-63a97045>Case Studies</a><a class=\"headers\" href=\"#testimonials\" data-v-63a97045>Testimonials</a><a class=\"headers\" href=\"#faq\" data-v-63a97045>FAQ</a>", 5)
const _hoisted_8 = { class: "gradient-wrap one" }
const _hoisted_9 = {
  id: "about",
  ref: "about",
  class: "about"
}
const _hoisted_10 = {
  id: "gio-stats",
  ref: "gio-stats",
  class: "about-stats"
}
const _hoisted_11 = { class: "gradient-wrap two" }
const _hoisted_12 = { id: "our-case-studies" }
const _hoisted_13 = { class: "gradient-wrap three" }
const _hoisted_14 = { id: "testimonials" }
const _hoisted_15 = { class: "gradient-wrap four" }
const _hoisted_16 = { class: "faq" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar_view = _resolveComponent("sidebar-view")!
  const _component_landing_header = _resolveComponent("landing-header")!
  const _component_sponsors_row = _resolveComponent("sponsors-row")!
  const _component_what_is_gio = _resolveComponent("what-is-gio")!
  const _component_gio_stats = _resolveComponent("gio-stats")!
  const _component_our_platform = _resolveComponent("our-platform")!
  const _component_our_case_studies = _resolveComponent("our-case-studies")!
  const _component_testimonials = _resolveComponent("testimonials")!
  const _component_faq_updated = _resolveComponent("faq-updated")!
  const _component_landing_footer = _resolveComponent("landing-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.scrollToComponent && $setup.scrollToComponent(...args))),
      class: "landing-page-container"
    }, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.scrollToTop($setup.startLink))),
        class: "logo-image",
        src: _imports_0,
        draggable: "false"
      }),
      _createElementVNode("ul", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "login-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleLoginClick && $setup.handleLoginClick(...args)))
        }, " Login / Register ")
      ]),
      ($setup.isMobile)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.op = true)),
            class: "material-icons menu-mobile"
          }, "menu"))
        : _createCommentVNode("", true),
      ($setup.isMobile)
        ? (_openBlock(), _createBlock(_component_sidebar_view, {
            key: 1,
            onClose: $setup.closeSidebar,
            op: $setup.op,
            view: 'creator'
          }, null, 8, ["onClose", "op"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_landing_header, {
      view: 'creator',
      currentCampaign: $setup.currentCampaign
    }, null, 8, ["currentCampaign"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(_component_sponsors_row, { "is-mobile": $setup.isMobile }, null, 8, ["is-mobile"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_what_is_gio, {
          view: 'creator',
          "is-mobile": $setup.isMobile
        }, null, 8, ["is-mobile"])
      ], 512),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_gio_stats, {
          view: 'creator',
          "is-mobile": $setup.isMobile
        }, null, 8, ["is-mobile"])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_our_platform, {
        "is-mobile": $setup.isMobile,
        view: 'creator'
      }, null, 8, ["is-mobile"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_our_case_studies, { "is-mobile": $setup.isMobile }, null, 8, ["is-mobile"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_testimonials, { "is-mobile": $setup.isMobile }, null, 8, ["is-mobile"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_faq_updated, {
          ref: "faq",
          id: "faq"
        }, null, 512)
      ])
    ]),
    _createVNode(_component_landing_footer, {
      view: 'creator',
      "is-mobile": $setup.isMobile
    }, null, 8, ["is-mobile"])
  ], 512))
}